import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { LitAnimatedPicture } from './../../../../../packages/frontend/components/lit-animated-picture.js';

@customElement('lit-alpaca-animated-picture')
export class AlpacaPicture extends LitAnimatedPicture {
    connectedCallback() {
        this.querySelectorAll(':scope > [data-lit-fallback]').forEach(element => element.remove());
        super.connectedCallback();
    }

    constructor() {
        super();
        // .alpaca-picture and the offer banners show the whole poster (object-fit: contain).
        this.fit = 'contain';
    }
    render() {
        return html` <div class="alpaca-picture">${super.render()}</div>`;
    }
}
